import { DatePipe } from '@angular/common'
import { Component, Input, computed, signal } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { RegistrationPrintEntry } from '@app/modules/database/models/registration-data.interface'
import { Registration } from '@app/modules/database/models/registration.model'
import { NbDialogRef } from '@nebular/theme'

@Component({
  selector: 'ngx-print-history',
  templateUrl: './print-history.component.html',
  styleUrls: ['./print-history.component.scss'],
  imports: [MatIconModule, DatePipe],
  standalone: true
})
export class PrintHistoryComponent {
  private _registrant = signal<Registration | null>(null)

  @Input() set registrant(value: Registration) {
    this._registrant.set(value || null)
  }

  readonly printEntries = computed(() => {
    const prints = this._registrant()?.prints || []
    return [...prints].map((print, index) => ({
      id: `${print?.printed_at || ''}-${print?.printed_by?.uuid || ''}-${index}`,
      person: this.extractPerson(print?.printed_by) || 'Unknown',
      printedAt: print?.printed_at || null,
      facialRecognition: !!print?.facialRecognition
    }))
  })

  constructor(private dialogRef: NbDialogRef<PrintHistoryComponent>) {}

  close() {
    this.dialogRef.close()
  }

  private extractPerson(value: RegistrationPrintEntry['printed_by']): string {
    if (!value) return ''
    return this.normalizePerson(value.name || '')
  }

  private normalizePerson(person: string): string {
    if (!person) return ''
    const normalized = person.toLowerCase().trim()
    if (normalized === 'self_print' || normalized === 'self_register') return 'Self Printed'
    return person.trim()
  }
}
